import { formatPrice } from '@ab-core/functions';
import type { PositionPriceObject } from '@ab-core/graphql/dist';
import { getTestIdProp } from '@ab-core/testing';
import Text from '@ab-core/text';
import type { MoneyObject } from '@ab-core/types/src';
import type { FC } from 'react';
import React, { useEffect, useState } from 'react';

export const Surcharges: FC<Pick<PositionPriceObject, 'priceObject'>> = (props) => {
    const [surchargesTotal, setSurchargesTotal] = useState<MoneyObject>({ centAmount: 0 });
    const { priceObject } = props;
    useEffect(() => {
        let totalCentAmount = 0;
        priceObject?.materialPriceSurcharges?.forEach((surcharge) => {
            totalCentAmount += surcharge?.value?.centAmount || 0;
        });

        setSurchargesTotal({ centAmount: totalCentAmount });
    }, [priceObject]);

    return (
        <div className="flex-justify-content-space-between">
            <Text>Zuschläge:</Text>
            <Text>
                {surchargesTotal?.centAmount === 0 ? (
                    '-'
                ) : (
                    <div {...getTestIdProp('product-card-surcharges')}>{formatPrice(surchargesTotal)}</div>
                )}
            </Text>
        </div>
    );
};
